import { setURL } from '@/api/apiUtil'

export default {
  // 上傳檔案
  uploadFile: {
    url: setURL('/WebAPI/File', {}, true),
    method: 'post'
  },
  // 取得檔案meta資訊
  getFileMeta: {
    url: setURL('/WebAPI/File', {}, true),
    method: 'get'
  },
  // 下載檔案
  downloadFile: {
    url: (uuid) =>
      setURL('/cfs/download/:uuid', { uuid }, true),
    method: 'get'
  },
  // 新增Meta資訊
  uploadMetaData: {
    url: setURL('/cfs/upload_meta', {}, true),
    method: 'post'
  },
  // 上傳檔案到Meta指定的位置
  uploadFileByMeta: {
    url: (uuid) =>
      setURL('/cfs/upload_file/:uuid', { uuid }, true),
    method: 'post'
  },
  // 刪除檔案
  deleteFile: {
    url: (uuid) => {
      return setURL('/cfs/del/:uuid', { uuid }, true)
    },
    method: 'delete'
  },
  // 查詢檔案meta data (cfs/meta 相較getFileMeta細節多)
  getMetaData: {
    url: (uuid) =>
      setURL('/cfs/meta/:uuid', { uuid }, true),
    method: 'get'
  },
  // 修改meta資訊
  updateMetaData: {
    url: (uuid) =>
      setURL('/cfs/update_meta/:uuid', { uuid }, true),
    method: 'post'
  },
  // 更新檔案attr
  updateMetaAttr: {
    url: (uuid) => {
      return setURL('/cfs/update_attr/:uuid', { uuid }, true)
    },
    method: 'post'
  },
  // 查詢meta清單 (attr必帶，至少為{})
  getMetaDataList: {
    url: setURL('/cfs/list_meta', {}, true),
    method: 'post'
  },
  // 預約下載
  scheduleDownload: {
    url: (nvrId) =>
      setURL('/WebAPI/api/Device/sendCmd/requestDownload/:nvrId', { nvrId }, true),
    method: 'post'
  },
  // 重新下載
  reDownload: {
    url: (nvrId) =>
      setURL('/WebAPI/api/Device/sendCmd/reDownload/:nvrId', { nvrId }, true),
    method: 'post'
  }
}
